import {useEffect, useState} from "react";
import {Box, Button, Grid, TextField, Typography} from "@material-ui/core";
import Dialog from "@material-ui/core/Dialog";
import * as React from "react";
import {withStyles} from "@material-ui/core/styles";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import {useLoadingDispatcher} from "../../context/LoadingContext";
import {setSnackbarDispatch, SnackbarActionTypes, useSnackbarDispatcher} from "../../context/SnackBarContext";
import {useAuthState} from "../../context/AuthContext";
import {CashUsersService} from "./CashUsersService";

const CashUserChangePassword = ({openDialog, handleClose, needRefresh, selectedItemId}) => {

    const loading = useLoadingDispatcher()
    const snackbar = useSnackbarDispatcher()
    const {token, fundID} = useAuthState()

    const service = new CashUsersService(fundID, token, snackbar, loading)

    const [userPassword, setUserPassword] = useState("");

    //Dialog-start
    const styles = (theme) => ({
        root: {
            margin: 0,
        },
        closeButton: {
            position: 'absolute',
            right: theme.spacing(1),
            top: theme.spacing(1),
            color: theme.palette.grey[500],
        },
    });
    const DialogTitle = withStyles(styles)((props) => {
        const {children, classes, onClose, ...other} = props;
        return (
            <MuiDialogTitle disableTypography className={classes.root} {...other}>
                <Typography variant="h6">{children}</Typography>
                {onClose ? (
                    <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
                        <CloseIcon/>
                    </IconButton>
                ) : null}
            </MuiDialogTitle>
        );
    });

    useEffect(() => {
        if (!openDialog) {
            clearFieldsData()
        }

    }, [openDialog])

    function doChange() {
        if (checkFieldsConditions()) {
            service.updateUserPassword(
                fundID,
                selectedItemId,
                userPassword,
            )

        }
    }

    function checkFieldsConditions() {
        if (userPassword.trim().length < 8 || userPassword.trim().length > 72) {
            snackbar(setSnackbarDispatch(SnackbarActionTypes.SHOW_WARNING, "رمز عبور باید بین 8 تا 72 کاراکتر باشد!"))
            return false
        }
        return true
    }

    function clearFieldsData() {
        setUserPassword("")
    }

    return (
        <Dialog onClose={handleClose} aria-labelledby="customized-dialog-title" open={openDialog}
                id="PersonalizedDialog">
            <DialogTitle id="customized-dialog-title" onClose={handleClose}>
                تغییر رمز عبور
            </DialogTitle>
            <section style={{padding: "1rem"}}>
                <Box className="d-flex flex-column">
                    <Grid xs={12} className="w-100 my-2">
                        <TextField
                            className="w-100"
                            id="outlined-disabled"
                            label="رمز عبور جدید"
                            variant="outlined"
                            value={userPassword}
                            onChange={e => {

                                setUserPassword(e.target.value)
                            }}
                        />
                    </Grid>
                    <Button onClick={doChange} color="primary">
                        بروزرسانی رمز عبور
                    </Button>
                </Box>
            </section>
        </Dialog>

    )

};

export default CashUserChangePassword